<div
  class="events-filter"
  [class.overlay-mode]="isOverlayMode"
  [class.mobile-overlay]="isMobileOverlay"
>
  @if (isOverlayMode) {
  <button
    class="close-btn"
    mat-icon-button
    (click)="closeOverlay()"
    aria-label="Luk filter"
  >
    <mat-icon>close</mat-icon>
  </button>
  }

  <div class="filter-header">
    <mat-icon>tune</mat-icon>
    <span>{{ effectiveSettings.title }}</span>
  </div>

  @if (effectiveSettings.showResultCount && !isLoading) {
  <div class="total-pill">
    <mat-icon>event</mat-icon>
    <span>{{ resultCount }} begivenheder</span>
  </div>
  } @if (isLoading) {
  <div class="filter-loading">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Indlæser filter…</span>
  </div>
  } @if (!isLoading && metadata) {
  <div class="filter-scroll">
  <!-- Search -->
  @if (effectiveSettings.showSearch) {
  <div class="filter-panel">
    <label class="panel-label">{{ effectiveSettings.searchPlaceholder }}</label>
    <div class="panel-input-wrap">
      <mat-icon class="panel-input-icon">search</mat-icon>
      <input
        class="panel-input"
        type="search"
        [ngModel]="criteria.searchText"
        (ngModelChange)="onSearchInput($event)"
        [placeholder]="effectiveSettings.searchPlaceholder"
      />
    </div>
  </div>
  }
  <!-- Event types -->
  @if (effectiveSettings.showEventTypes) {
  <div class="chip-row">
    <span class="section-label">Type</span>
    <div class="chips">
      <button
        type="button"
        class="chip"
        [class.active]="typeUddannelser"
        (click)="typeUddannelser = !typeUddannelser; onEventTypesChange()"
      >
        Uddannelser
        <span
          class="facet-count"
          [class.is-zero]="eventTypeCount('education') === 0"
          >{{ eventTypeCount("education") }}</span
        >
      </button>
      @if (visibility?.showExercises) {
      <button
        type="button"
        class="chip"
        [class.active]="typeOvelser"
        (click)="typeOvelser = !typeOvelser; onEventTypesChange()"
      >
        Øvelser
        <span
          class="facet-count"
          [class.is-zero]="eventTypeCount('exercise') === 0"
          >{{ eventTypeCount("exercise") }}</span
        >
      </button>
      }
      <button
        type="button"
        class="chip"
        [class.active]="typeKurser"
        (click)="typeKurser = !typeKurser; onEventTypesChange()"
      >
        Kurser
        <span
          class="facet-count"
          [class.is-zero]="eventTypeCount('course') === 0"
          >{{ eventTypeCount("course") }}</span
        >
      </button>
      <button
        type="button"
        class="chip"
        [class.active]="typeAktiviteter"
        (click)="typeAktiviteter = !typeAktiviteter; onEventTypesChange()"
      >
        Aktiviteter
        <span
          class="facet-count"
          [class.is-zero]="eventTypeCount('activity') === 0"
          >{{ eventTypeCount("activity") }}</span
        >
      </button>
    </div>
  </div>
  }
  <!-- Toggles -->
  <div class="toggle-row">
    <mat-checkbox
      [(ngModel)]="criteria.hideSubEvents"
      (ngModelChange)="onToggleChange()"
    >
      Skjul underbegivenheder @if (hiddenCount('subEvents') > 0) {
      <span class="facet-count toggle-count">{{
        hiddenCount("subEvents")
      }}</span>
      }
    </mat-checkbox>
    @if (visibility?.showHideFull) {
    <mat-checkbox
      [(ngModel)]="criteria.hideFullEvents"
      (ngModelChange)="onToggleChange()"
    >
      Skjul fyldte @if (hiddenCount('fullEvents') > 0) {
      <span class="facet-count toggle-count">{{
        hiddenCount("fullEvents")
      }}</span>
      }
    </mat-checkbox>
    } @if (visibility?.showHideParticipated) {
    <mat-checkbox
      [(ngModel)]="criteria.hideParticipatedEvents"
      (ngModelChange)="onToggleChange()"
    >
      Skjul mine deltagelser @if (hiddenCount('participated') > 0) {
      <span class="facet-count toggle-count">{{
        hiddenCount("participated")
      }}</span>
      }
    </mat-checkbox>
    } @if (showGroupCalendarEventsFilter) {
    <mat-checkbox
      [(ngModel)]="criteria.showGroupCalendarEvents"
      (ngModelChange)="onToggleChange()"
    >
      Vis gruppekalender-begivenheder
    </mat-checkbox>
    }
  </div>
  <!-- Organisation -->
  @if (effectiveSettings.showOrganizations) {
  <div class="filter-panel">
    <label class="panel-label">Organisation</label>
    <app-filter-multi-select
      [displayText]="formatSelectedOrganizations()"
      [options]="organizationSelectOptions"
      [selectedValues]="criteria.organizationIds"
      [inOverlay]="isOverlayMode"
      [mobileOverlay]="isMobileOverlay"
      (selectedValuesChange)="onOrganizationIdsChange($event)"
      (searchChange)="onSelectSearchChange('org', $event)"
    />
  </div>
  }
  <!-- Educational paths -->
  @if (visibility?.showEducationalPaths) {
  <div class="filter-panel">
    <label class="panel-label">Uddannelsesveje</label>
    <app-filter-multi-select
      [displayText]="formatSelectedPaths()"
      [options]="educationalPathSelectOptions"
      [selectedValues]="criteria.educationalPathIds"
      [inOverlay]="isOverlayMode"
      [mobileOverlay]="isMobileOverlay"
      (selectedValuesChange)="onPathsChange($event)"
      (searchChange)="onSelectSearchChange('path', $event)"
    />
  </div>
  } @if (showPathVersionDropdown()) {
  <div class="filter-panel">
    <label class="panel-label">Version</label>
    <mat-select
      class="panel-select"
      [ngModel]="selectedPathVersionId"
      (ngModelChange)="onPathVersionChange($event)"
      panelClass="filter-select-panel"
    >
      @for (v of pathVersions; track v.version_id) {
      <mat-option [value]="v.version_id">
        {{ getPathVersionLabel(v) }}
      </mat-option>
      }
    </mat-select>
  </div>
  }
  <!-- Modules -->
  @if (visibility?.showModules) {
  <div class="filter-panel">
    <label class="panel-label">Moduler</label>
    <app-filter-multi-select
      [displayText]="formatSelectedModules()"
      [options]="moduleSelectOptions"
      [selectedValues]="criteria.moduleIds"
      [inOverlay]="isOverlayMode"
      [mobileOverlay]="isMobileOverlay"
      (selectedValuesChange)="onModuleIdsChange($event)"
      (searchChange)="onSelectSearchChange('module', $event)"
    />
  </div>
  }
  <!-- Locations -->
  @if (visibility?.showLocations) {
  <div class="filter-panel">
    <label class="panel-label">Lokation</label>
    <app-filter-multi-select
      [displayText]="formatSelectedLocations()"
      [options]="locationSelectOptions"
      [selectedValues]="criteria.locationGuids"
      [inOverlay]="isOverlayMode"
      [mobileOverlay]="isMobileOverlay"
      (selectedValuesChange)="onLocationGuidsChange($event)"
      (searchChange)="onSelectSearchChange('location', $event)"
    />
  </div>
  }
  <!-- Distance -->
  @if (visibility?.showDistance) {
  <mat-expansion-panel class="filter-panel distance-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>Distance</mat-panel-title>
      @if (criteria.distanceFilter?.latitude) {
      <mat-panel-description>
        {{
          criteria.distanceFilter.radiusKm
            ? criteria.distanceFilter.radiusKm + " km"
            : "Ingen grænse"
        }}
      </mat-panel-description>
      }
    </mat-expansion-panel-header>
    <button
      mat-stroked-button
      type="button"
      class="loc-btn"
      (click)="useMyLocation()"
    >
      <mat-icon>my_location</mat-icon>
      Brug min nuværende placering
    </button>
    @if (locationError) {
    <p class="loc-error">{{ locationError }}</p>
    } @if (criteria.distanceFilter?.latitude) {
    <p class="loc-coords">
      {{ criteria.distanceFilter.latitude | number : "1.4-4" }},
      {{ criteria.distanceFilter.longitude | number : "1.4-4" }}
    </p>
    } @if (criteria.distanceFilter?.latitude) {
    <div class="distance-controls">
      <label class="section-label">Maks afstand (km) — 0 = ingen grænse</label>
      <mat-slider min="0" max="200" step="5" discrete>
        <input
          matSliderThumb
          [ngModel]="distanceSliderValue"
          (ngModelChange)="onDistanceSliderChange($event)"
        />
      </mat-slider>
      <input
        type="number"
        class="dist-input"
        min="0"
        max="500"
        [ngModel]="criteria.distanceFilter.radiusKm ?? ''"
        (ngModelChange)="onDistanceInputChange($event)"
        placeholder="Ingen grænse"
      />
      <button mat-button type="button" (click)="clearDistance()">
        Ryd placering
      </button>
    </div>
    }
  </mat-expansion-panel>
  }
  </div>
  @if (effectiveSettings.showResetButton) {
  <div class="filter-actions">
    <button
      type="button"
      class="reset-btn reset-btn-native"
      (click)="onClearFiltersClick($event)"
    >
      Ryd filter
    </button>
  </div>
  } }
</div>
